import axios from 'axios';

const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Allow-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': true,
  'Access-Control-Allow-Headers': 'x-requested-with'
}

const { REACT_APP_BACKEND_URL: BACKEND_URL } = process.env;

const Api = axios.create({
  baseURL: BACKEND_URL,
  timeout: 0,
  withCredentials: true,
  mode: 'no-cors',
  crossDomain: true,
  credentials: 'same-origin',
  headers
});

const token = async (access_token, access_url) => {
  if (!access_token) return null;
  return Api.put(`${!!access_url ? access_url : '/'}link/token`, {}, { 
    headers: { 
      ...headers, 
      'x-app-token': access_token,
      'x-fanthon-token': access_token,
    }});
};

export default {
  token,
};